import React from 'react';
import Form from 'components/form';
import { useTranslation } from 'i18n';
import { string, object } from 'yup';
import Fullscreen, {
  BackButton,
  Header,
  HeaderControls,
  NameTextInput,
} from './style';
import styled from 'styled-components';
import { WithMargin } from 'components/layout';
import ImagePreview from './image-preview';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import { NodeModalInput } from 'types';
import { SurfaceImageNode } from 'graphql/types';
import useCanCreateOrEditSurfaceNode from 'routes/surface/components/node-modal-form/hooks/use-can-create-or-edit-surface-node';
import withForm from 'components/form/hoc/with-form';

const image = './myImage.png';
const thumb = {
  width: 54,
  height: 26,
};

const StyledSlider = styled.input`
  height: 5px;
  background-color: '#040';
  outline: none;
  transition: opacity 0.2s;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: ${thumb.width}px;
    height: ${thumb.height}px;
    border: 0;
    background: url(${image});
    cursor: pointer;
    border-radius: 2px;
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    outline: none;
  }

  &::-moz-range-thumb {
    width: ${thumb.width}px;
    height: ${thumb.height}px;
    border: 0;
    background: url(${image});
    cursor: pointer;
    outline: none;
    border-radius: 2px;
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
  }
`;

const Styles = styled.div`
  .slider {
    display: block;
  }
`;

const App = ({ form }) => {
  const [state, setState] = React.useState(1);
  // const [size, setSize] = React.useState({});
  const [ratio, setRatio] = React.useState(1.0);

  const handleOnChange = (event: any) => {
    setState(event.target.value);

    form.setFieldValue('size', {
      width: event.target.value * 750,
      height: event.target.value * 750 * ratio,
    });
  };

  React.useEffect(() => {
    try {
      const { size } = form.values;
      const ratio = size.height / size.width;
      setState(form.values.size.width / 750);
      // setSize(size)
      setRatio(ratio);
      console.warn('XXXx FORM', form.values);
      console.warn('XXXx FORM', form.values.size.width / 500, size, ratio);
    } catch (error) {
      setState(2000);
    }
  }, []);

  return (
    <Styles>
      <input
        name="scale"
        type="range"
        min={1}
        max={10}
        value={state}
        className="slider"
        onChange={handleOnChange}
      />
      {/* <div className="value">{state}</div> */}
    </Styles>
  );
};

const App2 = withForm(App);

// export default (props) => (
//     <StyledSlider type="range" {...props} />
// )
export interface ImageNodeFormProps {
  onSubmit: any;
  onCancel: any;
  backButton?: Function;
  initialValues: NodeModalInput<any>;
}

function createValidationSchema(t) {
  return function () {
    return object().shape({
      name: string().required(t('name is required')),
      url: string().required(t('url is required')),
    });
  };
}

function ImageNodeForm({
  initialValues,
  onSubmit,
  ...props
}: ImageNodeFormProps) {
  const { t } = useTranslation();
  const validationSchema = React.useMemo(createValidationSchema(t), []);

  const { canCreateOrEdit, cannotEdit } = useCanCreateOrEditSurfaceNode(
    initialValues,
  );

  const submitLabel = initialValues.id ? t('Update image') : t('Save image');

  async function handleSubmit(values, actions) {
    console.warn('XXXx SUBMIT', values, actions);
    await onSubmit(values, actions);
    // This is hiding the modal :)
    props.onCancel();
  }

  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}>
      {(form) => {
        return (
          <Fullscreen.Wrapper>
            <Header>
              {props.backButton && props.backButton(BackButton)}
              <NameTextInput
                autoFocus
                disabled={cannotEdit}
                name="name"
                placeholder={t('Name of document')}
                noBorder
                secondary
              />
              <HeaderControls>
                <WithMargin right="15px">
                  <Form.Button
                    label={t('Close')}
                    onClick={props.onCancel}
                    secondary
                  />
                </WithMargin>
                {canCreateOrEdit && (
                  <Form.SubmitButton
                    label={submitLabel}
                    onClick={form.handleSubmit}
                  />
                )}
              </HeaderControls>
            </Header>
            <Fullscreen.Content isImage>
              <App form={form}></App>
              <ImagePreview url={form.values.url} />
            </Fullscreen.Content>
          </Fullscreen.Wrapper>
        );
      }}
    </Form>
  );
}

export default ImageNodeForm;
